module.exports = __webpack_public_path__ + "static/media/hudson_thumb_even.3683138b.jpg";